var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorporateBriefcase(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 12H34V8C34 5.794 32.206 4 30 4H18C15.794 4 14 5.794 14 8V12H8C5.794 12 4 13.794 4 16V22H44V16C44 13.794 42.206 12 40 12ZM18 8H30V12H18V8ZM28 28H20V24H4V38C4 40.206 5.794 42 8 42H40C42.206 42 44 40.206 44 38V24H28V28Z",
    fill: "#FFC003"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorporateBriefcase);
export default __webpack_public_path__ + "static/media/CorporateBriefcase.4d94271b3725683dd0236cf6c11f8c49.svg";
export { ForwardRef as ReactComponent };